import { Stack } from "@mui/material";
import { PrimaryPaper } from "Components/Shared/PrimaryPaper";
import { ProfilePhotoSection } from "Components/UserAccount/Shared/ProfilePhotoSection";
import { BioCard } from "Components/UserAccount/Shared/PublicInformation/BioCard";
import { EmailCard } from "Components/UserAccount/Shared/PublicInformation/EmailCard";
import { HandleCard } from "Components/UserAccount/Shared/PublicInformation/HandleCard";
import { IdentityCard } from "Components/UserAccount/Shared/PublicInformation/IdentityCard";
import { PhoneCard } from "Components/UserAccount/Shared/PublicInformation/PhoneCard";
import type { TabItem } from "Components/Shared/Tabs/QueryParamTabs";
import type { PartyDto } from "Infrastructure/Api/Api";
import { Resources, type TFunction } from "Translations/Resources";

type Props = {
  party: PartyDto;
};

/**
 * "Basic information" tab (ZS-1320): the user's profile-facing data — photo and one card
 * per value (identity with the public/private profile switch, handle, bio, phone, e-mail),
 * each editable in its own dialog. Shared by all three role account details via the
 * factory below.
 */
export const PublicInformationTab = ({ party }: Props) => (
  <PrimaryPaper>
    <Stack gap={4}>
      <ProfilePhotoSection />
      <Stack gap={2}>
        <IdentityCard party={party} />
        <HandleCard />
        <BioCard />
        <PhoneCard party={party} />
        <EmailCard party={party} />
      </Stack>
    </Stack>
  </PrimaryPaper>
);

export const getPublicInformationTab = (
  t: TFunction,
  party: PartyDto,
): TabItem => ({
  id: "publicInformation",
  label: t(Resources.Components.Account.PublicInformationTab),
  content: <PublicInformationTab party={party} />,
});
